export default "__VITE_ASSET__Bybzoh1z__"